import { useEffect, useCallback, useRef } from "react";
import { Backdrop } from "@mui/material";
import { ReactComponent as CloseIcon } from "components/icons/cross-black.svg";
import { BaseButton } from "components/buttons/BaseButton";
import { PlusButton } from "components/buttons";
import { BASE_BUTTON, WITH_CIRCLE_BUTTON } from "./constants";
import "./style/Popup.scss";

interface IPopupProps {
  onClose?: () => void;
  isOpen: boolean;
  title?: string;
  children: React.ReactNode;
  popupClass?: string;
  [x:string]: any;
}

export const Popup = (props: IPopupProps) => {
  const {
    onClose,
    isOpen,
    title,
    children,
    popupClass,
    btnProps: {
      type = null,
      title: btnTitle = null,
      onClick = null,
      disabled = null,
      formId = null,
      btnType = null
    } = {}
  } = props;
  const popupRef = useRef<HTMLInputElement>(null);

  const keyPress = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === "Escape" && isOpen && onClose) {
        onClose();
      }
    },
    [onClose, isOpen]
  );

  useEffect(() => {
    document.addEventListener("keydown", keyPress);

    return () => document.removeEventListener("keydown", keyPress);
  }, [keyPress]);

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("noScroll");
    } else {
      document.body.classList.remove("noScroll");
    }

    return () => document.body.classList.remove("noScroll");
  }, [isOpen]);

  const closePopup = (e: React.MouseEvent) => {
    if (popupRef.current === e.target && onClose) {
      onClose();
    }
  };

  return (
    <Backdrop
      open={isOpen}
      onClick={closePopup}
      ref={popupRef}
      sx={{
        zIndex: "var(--popupZ)"
      }}
      className={popupClass}
    >
      <div className="Popup">
        {title && (
          <div className="Popup-Header">
            <h4>{title}</h4>
          </div>
        )}
        {onClose && <button className="Popup-Close" onClick={onClose}>
          <CloseIcon />
        </button>}
        <div className="Popup-Content">
          {children}
        </div>
        {type === BASE_BUTTON && (
          <div className="Popup-BtnBase">
            <BaseButton
              onClick={onClick}
              disabled={disabled}
              form={formId}
              type={btnType}
            >{btnTitle}</BaseButton>
          </div>
        )}
        {type === WITH_CIRCLE_BUTTON && (
          <div className="Popup-BtnWithCircle">
            <PlusButton onClick={onClick} hint={btnTitle} />
            <button onClick={onClick}>{btnTitle}</button>
          </div>
        )}
      </div>
    </Backdrop>
  );
};
